import React from "react";
import { SettingsUpdate } from "./about-us";

const HowToPlay = () => (
	<SettingsUpdate type={"howToPlay"} title="Instructions on How ot Play" />
);

export default HowToPlay;
